//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ArticleCard from '@/components/Cards/ArticleCard.vue';
export default {
    name: 'Blog',
    components: {
        ArticleCard,
    },
    async asyncData({ $axios, error, i18n, redirect, localePath }) {
        if (i18n.locale === 'en') {
            return redirect(localePath('/'));
        }

        let model = {};

        await $axios
            .$get('/category/by-slug-path?path=/blog')
            .then((res) => {
                if (res.success === 1) {
                    model = res.data;
                }
            })
            .catch((err) => {
                return error({ statusCode: err.response?.status, message: err.response?.statusText });
            });

        if (!model) {
            return error({ statusCode: 404, message: i18n.t('errors.page_not_found') });
        }

        return {
            model,
        };
    },
    head() {
        const meta = [
            {
                hid: 'title',
                name: 'title',
                content: this.model.title,
            },
            {
                hid: 'og-title',
                property: 'og:title',
                content: this.model.title,
            },
            {
                hid: 'description',
                name: 'description',
                content: this.model.lead,
            },
            {
                hid: 'og-description',
                property: 'og:description',
                content: this.model.lead,
            },
        ];

        return {
            title: this.model.title,
            meta,
        };
    },
};
